import { SET_SPECIAL, CLEAR_SPECIAL } from '../actions/specials';

const ACTION_HANDLERS = {
  [SET_SPECIAL]: (state, action) => {
    const {
      data: { modules },
    } = action;
    return Object.assign({}, state, { modules: modules.module });
  },

  [CLEAR_SPECIAL]: () => initialState,
};

const initialState = { modules: [] };
export default function specialsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
